import { themeAtom } from "../../shared/atoms";
import RatingRow from "../../voyage-assessment/components/RatingRow";
import { VesselRatings } from "../../voyage-assessment/models/voyage-assesment.models";
import { getVesselRatings } from "../../voyage-assessment/services/voyage-assesment.service";
import QualityRating from "./QualityRating";
import { SafetyScore } from "./SafetyScore";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { twMerge } from "tailwind-merge";

// TODO Review and clean. Not all props are needed.
// interface Props {
//   data: {
//     overall_owner: TOwnerRating;
//     quality_ratings: TQualityRatings;
//     extra_info: TExtraInfo;
//   };
// }

const OwnerRating = () => {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselCode, vesselName } = useParams();
  const [vesselRatings, setVesselRatings] = useState<VesselRatings>();

  useEffect(() => {
    const fetchVoyageSequenceItinerary = async () => {
      try {
        const vesselRatings = await getVesselRatings(imoNumber, vesselCode, vesselName);
        setVesselRatings(vesselRatings);
      } catch (error) {}
    };

    if (imoNumber && vesselCode && vesselName) {
      fetchVoyageSequenceItinerary();
    }
  }, [imoNumber, vesselCode, vesselName]);

  // Average
  const averageOwnerRating = getAverage(vesselRatings);
  const averageToShow = averageOwnerRating === "-" ? "-" : averageOwnerRating.toFixed(2);

  return (
    <div data-test="owner-rating" className={twMerge("flex gap-12", theme.home.tailwind.textDefault)}>
      {/* Overall owner rating */}
      {/* @to-do: adapt depending on backend mapping */}
      <div className="flex flex-col gap-2">
        <p className="text-[16px] font-bold">Overall owner rating</p>
        <div className="flex flex-col gap-2">
          <p className="font-bold">
            <span className="text-4xl">{averageToShow}</span>
            <span className={twMerge("text-[14px] font-bold", theme.headerComponent.notifications.iconShape)}>/5</span>
          </p>
          <RatingRow
            rating={averageOwnerRating === "-" ? 0 : averageOwnerRating}
            showStarCount={false}
            isVertical
            readonly={true}
          />
        </div>
        <p className={twMerge("text-[14px]", theme.headerComponent.notifications.iconShape)}>
          Based on {vesselRatings?.count ?? 0} assessments
        </p>
      </div>

      <div className={twMerge("w-[1px]", theme.vesselDetails.verticalLine)} />
      {/* Quality ratings */}
      <div className="flex flex-[75%] flex-wrap">
        <p className="] mb-4 flex-[100%] text-[16px] font-bold">Quality ratings</p>

        <div className="flex">
          <div className="flex flex-wrap justify-start">
            <div className="mb-6 flex-[33%] flex-grow-0">
              <QualityRating number={vesselRatings?.flexibility ?? "-"} title="Flexibility" readonly={true} />
            </div>
            <div className="mb-6 flex-[33%] flex-grow-0">
              <QualityRating
                number={vesselRatings?.transparencyAndComunication ?? "-"}
                title="Communication"
                readonly={true}
              />
            </div>
            <div className="mb-6 flex-[33%] flex-grow-0">
              <QualityRating
                number={vesselRatings?.fleetMaintenance ?? "-"}
                title="Fleet maintenance"
                readonly={true}
              />
            </div>
            <div className="mb-6 flex-[33%] flex-grow-0">
              <QualityRating
                number={vesselRatings?.promptnessAndCoorperation ?? "-"}
                title="Promptness and cooperation"
                readonly={true}
              />
            </div>
            <div className="mb-6 flex-[33%] flex-grow-0">
              <QualityRating number={vesselRatings?.crew ?? "-"} title="Crew" readonly={true} />
            </div>
            <SafetyScore vesselRatings={vesselRatings} />
          </div>
        </div>
      </div>
    </div>
  );
};

const getAverage = (vr: VesselRatings | undefined): number | "-" => {
  if (!vr) return "-";

  const ratings = [
    vr.flexibility,
    vr.transparencyAndComunication,
    vr.fleetMaintenance,
    vr.promptnessAndCoorperation,
    vr.crew,
  ];

  const numericRatings = ratings.filter((rating) => typeof rating === "number") as number[];

  if (numericRatings.length === 0) return "-";

  const sum = numericRatings.reduce((acc, val) => acc + val, 0);

  return sum / numericRatings.length;
};
export default OwnerRating;
